<template>
    <main class="page__content">
        <div class="plain-content">
            <div class="plain-content__inner">
                <div class="plain-content__header">
                    <h1>Teilnahmebedingungen</h1>
                </div>
                <div class="plain-content__body">
                    <ol>
                        <li>
                            <h2 class="h3">
                                F&#246;rderf&#228;hige Projekte
                            </h2>
                            <ol>
                                <li>
                                    Mit der Aktion &#8222;<em>Velbert zeigt Herz</em>&#8220;
                                    m&#246;chte die Stadtwerke Velbert GmbH, Kettwiger Stra&#223;e 2,
                                    42549 Velbert (nachfolgend &#8222;            <strong>Stadtwerke Velbert</strong>&#8220;), als Initiator einen
                                    Beitrag zur Verbesserung der Lebensqualit&#228;t im Kreis Velbert
                                    leisten und Projekte unterst&#252;tzen, die sich genau darum
                                    bem&#252;hen. Hierzu stellen die Stadtwerke Velbert aus eigenen
                                    Mitteln einen speziellen F&#246;rdertopf zur Verf&#252;gung.
                                </li>
                                <li>
                                    Um die F&#246;rderung bewerben k&#246;nnen sich gemeinn&#252;tzige
                                    Vereine mit Projekten, die im Versorgungsgebiet der
                                    Stadtwerke Velbert stattfinden oder starten (nachfolgend &#8222;            <strong>Antragsteller</strong>&#8220;). Die Projekte zeichnen sich
                                    dadurch aus, dass sie sich f&#252;r ein lebenswerteres Velbert
                                    und/oder seine B&#252;rger engagieren und stark machen. Die
                                    Projekte k&#246;nnen daher aus den Bereichen Sport, Musik, Kultur,
                                    Bildung, Brauchtum, Soziales, Technik, Forschung oder Umwelt
                                    stammen.
                                </li>
                                <li>
                                    Voraussetzung f&#252;r eine F&#246;rderung durch die Stadtwerke
                                    Velbert ist, neben dem f&#246;rderungsw&#252;rdigen Zweck im Sinne
                                    von Ziffer 1.1 bzw. 1.2, die Ans&#228;ssigkeit des Antragstellers
                                    bzw. die Durchf&#252;hrung des Projektes im Kreis Velbert, um
                                    sicher zu stellen, dass sich die F&#246;rderung hier auswirkt.
                                    Dar&#252;ber hinaus ist die Anerkennung der Gemeinn&#252;tzigkeit
                                    des Antragstellers durch die Finanzbeh&#246;rden Voraussetzung
                                    f&#252;r die F&#246;rderung.
                                </li>
                                <li>
                                    Eine F&#246;rderung wird nicht gew&#228;hrt, wenn:
                                    <br>
                                    <ol>
                                        <li>
                                            bei dem Antragsteller bzw. in dessen Organisation eine
                                            Profi-Abteilung unterhalten wird;
                                        </li>
                                        <li>
                                            bereits eine andere F&#246;rderung seitens der Stadtwerke
                                            Velbert gew&#228;hrt wird oder wurde (keine
                                            Doppelf&#246;rderung);
                                        </li>
                                        <li>
                                            bereits im Rahmen dieses Programms eine F&#246;rderung von
                                            &#8364; 500,00 durch die Stadtwerke Velbert f&#252;r das
                                            Projekt gew&#228;hrt wurde;
                                        </li>
                                        <li>
                                            das gesamte F&#246;rderbudget ausgesch&#246;pft ist;
                                        </li>
                                        <li>
                                            der Schwerpunkt des Projektes nicht einem
                                            f&#246;rderw&#252;rdigen sozialen, kulturellen,
                                            &#246;kologischen, sportlichen, wissenschaftlichen Zweck oder
                                            der Brauchtumspflege dient;
                                        </li>
                                        <li>
                                            eine politische Partei, parteinahe Organisation oder
                                            Gewerkschaft das Projekt betreibt;
                                        </li>
                                        <li>
                                            die F&#246;rderung unmittelbar oder mittelbar einem Amts- oder
                                            Mandatstr&#228;ger der Stadt Velbert oder einem Bewerber um ein
                                            &#246;ffentliches Amt zugute kommen soll;
                                        </li>
                                        <li>
                                            das Projekt gegen die guten Sitten verst&#246;&#223;t, als
                                            gewaltverherrlichend angesehen werden kann oder einem
                                            extremistischen politischen Zweck dient;
                                        </li>
                                        <li>
                                            religi&#246;se Bewegungen, Einrichtungen oder Gemeinden als
                                            Projekttr&#228;ger auftreten und im Rahmen des Projektes auch
                                            eine missionarische T&#228;tigkeit erfolgt oder erfolgen kann;
                                        </li>
                                        <li>
                                            Projekte nur die Spendenerhebung zur Weiterleitung an andere
                                            Projekte zum Ziel haben (z.B. Charity Clubs);
                                        </li>
                                        <li>
                                            Projekte die F&#246;rderung einer einzelnen Person zum Ziel
                                            haben;
                                        </li>
                                        <li>
                                            der Antragsteller mit Gewinnerzielungsabsicht am
                                            Wirtschaftsverkehr teilnimmt; oder
                                        </li>
                                        <li>
                                            der Antragsteller von einem Mitarbeiter der Stadtwerke Velbert
                                            oder dessen direkten Angeh&#246;rigen betrieben oder bestimmt
                                            wird.
                                        </li>
                                    </ol>
                                </li>
                            </ol>
                        </li>

                        <li>
                            <h2 class="h3">
                            Aktionszeitraum
                            </h2>
                            Die Spendenaktion &#8222;<em>Velbert zeigt Herz</em>&#8220; beginnt im
                            November 2018. &#220;ber die Beendigung der Aktion entscheiden die
                            Stadtwerke Velbert.
                        </li>
                        <li>
                            <h2 class="h3">
                            Bewerbungsverfahren
                            </h2>
                            <ol>
                                <li>
                                    Die Teilnahme ist ausschlie&#223;lich durch Anmeldung &#252;ber die
                        Webseite            <a href="https://velbert-zeigt-herz.de">velbert-zeigt-herz.de</a>
                                    m&#246;glich.
                                </li>
                                <li>
                                    Eine Bewerbung ist grunds&#228;tzlich bis zum Ende des
                                    Aktionszeitraums gem&#228;&#223; Ziffer 2 m&#246;glich.
                                </li>
                                <li>
                                    Alle Angaben im Anmeldeformular m&#252;ssen vollst&#228;ndig und
                                    wahrheitsgem&#228;&#223; angegeben werden, insbesondere muss ein
                                    vollj&#228;hriger, bevollm&#228;chtigter Ansprechpartner des
                                    Vereins genannt werden.
                                </li>
                                <li>
                                    Mit dem Upload von Inhalten (insbesondere Bilder) erkl&#228;rt der
                                    Antragsteller, dass deren bestimmungsgem&#228;&#223;e Verwendung
                                    durch die Stadtwerke Velbert im Rahmen dieser Aktion keine Rechte
                                    Dritter verletzt.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <h2 class="h3">
                                Kosten
                            </h2>
                            Die Bewerbung und Teilnahme an der Aktion &#8222;Velbert zeigt Herz&#8220;
                            ist kostenlos. Aufwendungen oder Kosten, die den Antragsstellern oder
                            Vereinen f&#252;r die Bewerbung entstehen, werden von den Stadtwerken
                            Velbert nicht &#252;bernommen oder erstattet.
                        </li>

                        <li>
                            <h2 class="h3">
                                Einwilligung in Ver&#246;ffentlichungen
                            </h2>
                            Mit der Anmeldung willigt der Antragsteller und die f&#252;r ihn handelnden
                            Personen darin ein, dass
                            <ol>
                                <li>
                                    die hochgeladenen Bilder im Rahmen der Website von &#8222;Velbert
                                    zeigt Herz&#8220;, f&#252;r die Stadtwerke Velbert-Facebookseite
                                    und -Webseite genutzt werden d&#252;rfen;
                                </li>
                                <li>
                                    der Name des Antragstellers, der vertretungsberechtigten
                                    Person(en), das Projekt sowie die F&#246;rdersumme in Publikationen
                                    und im Gesch&#228;ftsbericht der Stadtwerke Velbert
                                    ver&#246;ffentlicht wird;
                                </li>
                                <li>
                                    der Antragsteller sowie die von ihm vertretenen Personen ihre
                                    N&#228;heverh&#228;ltnisse gegen&#252;ber Mitarbeitern der
                                    Stadtwerke Velbert, die an der Vergabe von F&#246;rderungen
                                    beteiligt sind, offenlegen;
                                </li>
                                <li>
                                    &#252;ber das Projekt und die F&#246;rderung sowie die f&#252;r den
                                    Antragsteller handelnden Personen im Zusammenhang mit der
                                    F&#246;rderung &#246;ffentliche Berichterstattung erfolgt,
                                    inklusive Fotoaufnahmen f&#252;r Pressever&#246;ffentlichungen und
                                    Werbenutzungen der Stadtwerke Velbert.
                                </li>
                            </ol>
                        </li>
                        <li>
                            <h2 class="h3">
                                Entscheidung &#252;ber F&#246;rderung
                            </h2>
                            <ol>
                                <li>
                                    &#220;ber die Auswahl der zur F&#246;rderung in Frage kommenden
                                    Projekte entscheiden die Stadtwerke Velbert anhand der in diesen
                                    Bedingungen niedergelegten Grunds&#228;tze nach eigenem Ermessen.
                                </li>
                                <li>
                                    Die H&#246;he des F&#246;rderbeitrags bemisst sich danach, wie
                                    viele &#8222;Herzen&#8220; im Wert von je &#8364; 0,50 die Kunden
                                    der Stadtwerke und andere Bewohner von Velbert im Rahmen der Aktion
                                    an das Projekt vergeben. Ein Projekt darf insgesamt 5 Monate lang
                                    Herzen sammeln. Nach Ende dieses Projektaktionszeitraums
                                    k&#246;nnen keine weiteren Herzen mehr vergeben werden. Maximal
                                    werden jedoch pro Projekt &#8364;500,00 (Maximalbetrag) im
                                    Aktionszeitraum ausgezahlt. <br>
                                    Die H&#246;he des Auszahlungsbetrags berechnet sich nach der Menge
                                    gespendeter Herzen am Aktionsende gem&#228;&#223; Ziffer 2, soweit nicht
                                    bereits vorher der Maximalbetrag erreicht ist. &#220;ber die Ausgabe der
                                    Herzen entscheiden die Stadtwerke Velbert nach eigenem Ermessen.
                                </li>

                                <li>
                                    F&#246;rderbetr&#228;ge werden erst ausbezahlt, wenn f&#252;r das
                                    Projekt Herzen im Gegenwert von mindestens &#8364; 10,00
                                    zusammengekommen sind. Wird diese Grenze bis zum Aktionsende nicht
                                    erreicht, verfallen die gesammelten Herzen.
                                </li>
                                <li>
                                    Die f&#252;r die F&#246;rderung ausgew&#228;hlten Vereine werden
                                    ausschlie&#223;lich &#252;ber die im Anmeldeprozess angegebene
                                    E-Mail-Adresse informiert.
                                </li>
                                <li>
                                    Die Auszahlung der Spende erfolgt auf das vom Antragsteller
                                    angegebene Bankkonto.
                                </li>
                                <li>
                                    Die f&#252;r F&#246;rderung ausgew&#228;hlten Antragsteller sind
                                    verpflichtet, binnen 4 Wochen nach Erhalt der Spendensumme eine
                                    Zuwendungsbescheinigung (Spendenquittung) auszustellen und den
                                    Stadtwerken Velbert auf dem Postweg zukommen zu lassen.
                                </li>
                                <li>
                                    Sollte sich im Laufe des Aktionszeitraum herausstellen, dass ein
                                    Versto&#223; gegen die in Ziffer 1 genannten Grunds&#228;tze
                                    gegeben ist oder war, kann das Projekt mit sofortiger Wirkung
                                    ausgeschlossen werden; die bislang gesammelten Herzen verfallen
                                    dann. In weniger gravierenden F&#228;llen kann der Antragsteller
                                    zun&#228;chst zu dem Vorwurf angeh&#246;rt werden.
                                </li>
                                <li>
                                    Ein Anspruch auf F&#246;rderung besteht nicht. Rechtsmittel sind
                                    ausgeschlossen.
                                </li>
                            </ol>
                        </li>

                        <li>
                            <h2 class="h3">
                                Haftung
                            </h2>
                            <ol>
                                <li>
                                    Die Stadtwerke Velbert haften auf Schadenersatz &#8211; gleich aus
                                    welchem Rechtsgrund &#8211; nur bei Vorsatz, grober
                                    Fahrl&#228;ssigkeit und leicht fahrl&#228;ssiger Verletzung
                                    wesentlicher Vertragspflichten (Kardinalpflichten). Wesentliche
                                    Vertragspflichten sind solche, deren Erf&#252;llung zur Erreichung
                                    des Ziels des Vertrags notwendig ist.
                                </li>
                                <li>
                                    Bei leicht fahrl&#228;ssiger Verletzung wesentlicher
                                    Vertragspflichten ist die Haftung der Stadtwerke Velbert begrenzt
                                    auf den Ersatz des vertragstypischen, vorhersehbaren Schadens.
                                    Insbesondere mittelbare Sch&#228;den werden nicht ersetzt.
                                </li>
                                <li>
                                    Die vorstehenden Haftungsbeschr&#228;nkungen gelten auch zugunsten
                                    der gesetzlichen Vertreter und Erf&#252;llungsgehilfen der
                                    Stadtwerke Velbert.
                                </li>
                                <li>
                                    Die vorstehenden Haftungsbeschr&#228;nkungen gelten nicht f&#252;r
                                    schuldhaft verursachte Sch&#228;den aus der Verletzung des Lebens,
                                    des K&#246;rpers oder der Gesundheit. Die Vorschriften des
                                    Produkthaftungsgesetzes bleiben unber&#252;hrt.
                                </li>
                                <li>
                                    Die Stadtwerke Velbert sind nicht verantwortlich f&#252;r die vom
                                    Antragsteller mitgeteilten Inhalte und werden vom jeweiligen
                                    Antragsteller von allen Anspr&#252;chen freigestellt, die Dritte
                                    insoweit gegen&#252;ber den Stadtwerke Velbert geltend machen.
                                </li>
                            </ol>
                        </li>

                        <li>
                            <h2 class="h3">
                                Schlussvorschriften
                            </h2>
                            <ol>
                                <li>
                                    Einen Rechtsanspruch auf Aufnahme in den Pool der potentiell
                                    f&#246;rderw&#252;rdigen Organisationen und Projekte gibt es nicht,
                                    ebenso wenig wie einen Rechtsanspruch auf die F&#246;rderung
                                    selbst.
                                </li>
                                <li>
                                    Die Stadtwerke Velbert sind berechtigt, die Fortsetzung der
                                    F&#246;rderaktion oder die Auszahlung von F&#246;rdergeldern
                                    auszusetzen oder &#8211; soweit schwerwiegende Gr&#252;nde
                                    vorliegen &#8211; g&#228;nzlich zu verweigern. Dies gilt
                                    insbesondere, wenn sich nach der Antragstellung oder
                                    F&#246;rderbewilligung herausstellen sollte, dass der Antragsteller
                                    oder sein Projekt die Anforderungen nach Ziffer 1 tats&#228;chlich
                                    nicht erf&#252;llt, oder eine ordnungsgem&#228;&#223;e
                                    Durchf&#252;hrung der Aktion nicht mehr gew&#228;hrleistet werden
                                    kann.
                                </li>
                                <li>
                                    Die F&#246;rderaktion unterliegt deutschem Recht.
                                </li>
                                <li>
                                    Es gelten die in der Datenschutzerkl&#228;rung niedergelegten
                                    Bestimmungen zum Datenschutz. Durch die Teilnahme an der
                                    Vereinsf&#246;rderaktion erkl&#228;rt sich der Teilnehmer
                                    ausdr&#252;cklich damit einverstanden, dass die Stadtwerke die
                                    erforderlichen Daten f&#252;r die Abwicklung der Aktion erheben,
                                    speichern und den mit der Durchf&#252;hrung beauftragten Partnern
                                    (Ortmann und Kollegen, Agentur Vierpartner) zug&#228;nglich machen
                                    d&#252;rfen. Es steht dem Teilnehmer jederzeit frei, per Widerruf
                                    die Einwilligung aufzuheben und somit von der Teilnahme
                                    zur&#252;ckzutreten.
                                </li>
                            </ol>
                        </li>
                        <!--
                        <li id="aktion">
                            <h2 class="h3">
                                Sonderaktion „Herzen-Starthilfe für grüne Projekte“
                            </h2>
                            <ol>
                                <li>
                                    Jedes grüne Projekt, dass vom 08.03.2024 bis zum 31.12.2024 eingestellt wird, erhält 100,00 Euro Starthilfe bereits zu Beginn der Spendensammlung. Damit kommen grüne Projekte deutlich schneller und einfacher zu dem von Ihnen benötigten Spenden-Budget.
                                </li>
                                <li>
                                    Den Startbonus von 100,00 Euro erhalten ausschließlich grüne Projekte. Ein Projekt gilt als „grün“ bzw. ökologisch nachhaltig, wenn es z.B. zur Ressourcenschonung, Abfallvermeidung, dem Artenschutz oder anderen ökologischen Zielen beiträgt. Ob ein Projekt die Voraussetzungen erfüllt, entscheidet ein Gremium der Stadtwerke Velbert.
                                </li>
                                <li>
                                    Die Aktion beginnt am 08.03.2024 und endet am 31.12.2024. Sie gilt für alle Projekte, die in diesem Zeitraum neu eingestellt werden. Bereits laufende Projekte, die sich beim Start der Aktion bereits öffentlich auf der Spendenplattform befinden, sind davon nicht betroffen.
                                </li>
                                <li>
                                    Für Projekte in dem Aktionszeitraum gilt ein Minimalspendenziel von EUR 300,00 auf der Spendenplattform.
                                </li>
                            </ol>
                        </li>
                        -->
                    </ol>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'PageTermsOfParticipation'
}
</script>



// WEBPACK FOOTER //
// src/components/PageTermsOfParticipation.vue